import { useEffect, useReducer } from 'react';

import type { AxiosError } from 'axios';

import { request } from 'core/services/bff/presenters';

import type { LoginBanners } from 'core/domains/loginBanners';
import { createReducer } from 'ui/pages/helpers/createReducer';

type LoginBannersType = {
  data: LoginBanners | undefined;
  isSuccess: boolean;
  isError: boolean;
  isLoading: boolean;
  error: AxiosError;
};

enum Action {
  setData = 'SET_DATA',
  setIsSuccess = 'SET_ISSUCCESS',
  setIsError = 'SET_ISERROR',
  setIsLoading = 'SET_ISLOADING',
  setError = 'SET_ERROR',
}

const defaultState = {
  data: undefined,
  isSuccess: false,
  isError: false,
  isLoading: false,
  error: {} as AxiosError,
};

const bannersReducer = createReducer<LoginBannersType>(Action);

export const useLoginBanners = () => {
  const [state, dispatch] = useReducer(bannersReducer, defaultState);

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: Action.setIsLoading, payload: '' });

      return await request
        .loginBanners()
        .then(({ data: response }) => {
          dispatch({ type: Action.setData, payload: response?.data?.items[0].data || {} });
          dispatch({ type: Action.setIsSuccess, payload: '' });
        })
        .catch((error) => {
          dispatch({ type: Action.setError, payload: error });
          dispatch({ type: Action.setIsError, payload: '' });
        });
    };

    fetchData();
  }, []);

  return {
    ...state,
  };
};
